export const PERMISSIONS = {
  SHOW_SIDENAV: "show_sidenav",
  SHOW_SHARE: "show_share",
  SHOW_TOPNAV: "show_topnav",
  SHOW_VIEWS: "show_views",
  SHOW_MAIN: "show_main",
  SHOW_BRIEF: "show_brief",
  SHOW_PROCESSES: "show_processes",
  SHOW_DATA: "show_data",
  SHOW_SETTINGS: "show_settings",
  SHOW_LICENSES: "show_licenses",
  SHOW_MANAGE_COLLECTIONS: "show_manage_collections",
  SHOW_FLOW_MANAGER: "show_flow_manager",
  SHOW_HISTORY: "show_history",
  SHOW_MODEL: "show_model",
  SHOW_ENVIRONMENTS: "show_environments",
  SHOW_GOVERNANCE: "show_governance",
  SHOW_ACTIVITY: "show_activity",
  SHOW_ASSISTANT: "show_assistant",
  SHOW_BRIEF_ADVISOR: "show_brief_advisor",
  SHOW_BRIEF_DEFINITION: "show_brief_definition",
  SHOW_BRIEF_SPECIFICATION: "show_brief_specification",
  SHOW_BRIEF_DEVELOPMENT: "show_brief_development",
  SHOW_BRIEF_QA: "show_brief_qa",
  SHOW_BRIEF_INTERACTIONS: "show_brief_interactions",

  NODE_EXECUTE: "node_execute",

  COLLECTIONS_SHOW_VIEW: "collections_show_view",
  COLLECTIONS_SHOW_ADD: "collections_show_add",
  COLLECTIONS_SHOW_DELETE: "collections_show_delete",
  COLLECTIONS_MODIFY_STRUCTURE: "collections_modify_structure",
};

export const getPermissionTarget = (permission) => {
  if (permission.startsWith("node_")) return "node";
  if (permission.startsWith("collections_")) return "collection";
  return "flow";
}

export const FLOW_PERMISSION_NAMES = new Set(
  Object.values(PERMISSIONS).filter((permission) => getPermissionTarget(permission) == "flow")
);
